"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PenNibAdd = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M15,20.9597885 C14.9873766,20.9634719 14.9746285,20.9669252 14.9617592,20.9701425 C14.8824386,20.9899727 14.8009854,21 14.7192236,21 L10.2807764,21 C9.72849166,21 9.28077641,20.5522847 9.28077641,20 C9.28077641,19.9182382 9.29080376,19.836785 9.31063391,19.7574644 L9.84672909,17.6130836 C8.62144293,16.5439891 8,15.1618268 8,13.5 C8,11.7294832 9.35123293,8.35140091 12.0586322,3.26506491 C12.1883833,3.02130423 12.4911744,2.92888117 12.7349351,3.05863223 C12.8227497,3.10537498 12.894625,3.17725026 12.9413678,3.26506491 C15.41264,7.90779387 16.7539875,11.1272475 16.9691621,13 L15.9626352,13 C15.7642457,11.5413865 14.775935,9.0401637 13,5.54321163 L13,13 L12,13 L12,5.54321163 C10.0010918,9.47921513 9,12.1537604 9,13.5 C9,14.9450791 9.55046666,16.098797 10.6718675,17 L13,17 L13,18 L10.7807764,18 L10.2807764,20 L15,20 L15,20.9597885 Z M19,17 L22,17 L22,18 L19,18 L19,21 L18,21 L18,18 L15,18 L15,17 L18,17 L18,14 L19,14 L19,17 Z" })));
};
PenNibAdd.displayName = 'PenNibAdd';
exports.default = PenNibAdd;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PenNibAdd.js.map